import { useRoute } from "vue-router";
import type Integration from "@/types/Integration";
import { useSnackbar } from "@/stores/snackbar";
import api from "@/api";

const REDIRECT_DELAY_MS = 3000;

export function useIntegrationAuth() {
  const route = useRoute();
  const snackbar = useSnackbar();

  function redirectToIntegration(
    integration: Integration,
    producerId: string,
    message = "Você será redirecionado para concluir a autenticação.",
  ): void {
    // Using `route.path` instead of `window.location.href` ensures this URL never carries
    // forward previous leftover query params
    const redirectUrl = `${window.location.origin}${route.path}`;

    const params = new URLSearchParams();
    params.append("state", btoa(JSON.stringify({ id: integration.id, redirect_url: redirectUrl })));

    const url = `${api.defaults.baseURL}/api/producers/${producerId}/integrations/${integration.id}/authorize?${params.toString()}`;

    snackbar.show(message, "warning");

    setTimeout(() => {
      window.location.href = url;
    }, REDIRECT_DELAY_MS);
  }

  return {
    redirectToIntegration,
  };
}
